import { useParams } from 'react-router-dom'
import PageCalling from 'src/components/common/PageCalling'

import useAPI from '../hooks/useAPI'
import Footer from 'src/components/common/Footer'
import Banner from 'src/components/common/Banner'
import Terms from 'src/components/views/RopForm/Terms'
import JoinSubmit from 'src/components/views/RopForm/JoinSubmit'
import PhoneVerification from 'src/components/views/RopForm/PhoneVerification'

import { RopFormWrap } from '../styles/styledcomponent/views/RopForm/RopForm'
import { useEffect } from 'react'
import {
  authKeyState,
  PartnerListData,
  TelTypeState,
  TermsListData,
  uiData,
} from 'src/recoil/common'
import { useRecoilState, useSetRecoilState } from 'recoil'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { PramsKeys } from 'src/types/type'
import useIsImgLoad from 'src/hooks/useIsImgLoad'
import { convertTermsData } from 'src/service/join'
import useSubmit from 'src/hooks/useSubmit'
import VulnerableCheckModal from 'src/components/common/VulnerableCheckModal'

const RopForm = (): JSX.Element => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const api = useAPI('requestTermsList')
  const submit = useSubmit(pcode ?? '')
  const { data: getTermsData, isSuccess, isLoading } = api?.useSetQuery({ PCode: pcode })
  const setAuthKey = useSetRecoilState(authKeyState)
  const setTermsListData = useSetRecoilState(TermsListData)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)
  const setTelType = useSetRecoilState(TelTypeState)
  const { banner1Ref, banner2Ref } = useIsImgLoad(isSuccess)
  const { onMoveToElement, RefInput } = useMoveScroll(banner2Ref)

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    switch (isSuccess) {
      case pcode === 'pinc_01':
        return setAuthKey(authKey)
      default:
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListData(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListData, setTelType, setUiData])

  return (
    <RopFormWrap mainBg={mainBg}>
      <PageCalling active={isLoading} />
      {isSuccess && (
        <>
          <Banner banner1Ref={banner1Ref} banner2Ref={banner2Ref} />
          <PhoneVerification
            onMoveToElement={onMoveToElement}
            RefInput={RefInput}
            submit={submit}
          />
          {!isErrorPartner && <Terms />}
          <JoinSubmit submit={submit} />
          <Footer />
        </>
      )}
      <VulnerableCheckModal submit={submit} />
    </RopFormWrap>
  )
}
export default RopForm
